import DashStatCard from '../../components/ui/DashStatCard'
import LineChart from '../../components/ui/LineChart'
import DashIcon from '../../components/ui/DashIcon'

const months = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Aoû','Sep','Oct','Nov','Déc']
const gmv    = [180,220,260,310,340,380,410,460,490,530,580,640]

export default function AdminAnalytics() {
  return (
    <>
      <div className="page-head">
        <div className="ph-titles">
          <h1>Analytics</h1>
          <p>Tableaux de bord avancés pour la direction.</p>
        </div>
        <div className="ph-actions">
          <button className="btn btn-ghost"><DashIcon name="download" size={14} /> Export complet</button>
        </div>
      </div>

      <div className="stat-grid stat-grid-4" style={{ marginBottom: 18 }}>
        <DashStatCard label="GMV (volume)"     value="2.84M DT" trend="+34% YoY"           icon="wallet" accent="green" />
        <DashStatCard label="Take rate"        value="11.8%"    trend="+0.4 pp"             icon="chart" />
        <DashStatCard label="NPS"              value="68"       trend="+8 ce trimestre"     icon="star" />
        <DashStatCard label="Churn livreurs"   value="3.2%"     trend="-1.1 pp" trendDir="down" icon="users" />
      </div>

      <div className="card chart-card">
        <div className="chart-head">
          <h3>Évolution GMV 12 mois</h3>
        </div>
        <div className="chart-body" style={{ height: 340 }}>
          <LineChart series={[{ data: gmv }]} labels={months} height={340} />
        </div>
      </div>
    </>
  )
}
